import { render, staticRenderFns } from "./WarehouseDesktop.vue?vue&type=template&id=17b31508"
import script from "./WarehouseDesktop.vue?vue&type=script&lang=js"
export * from "./WarehouseDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports